import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { AlignCenter } from '../../../global/commonStyle';

interface Props {
  isDark?: string;
}
const MainContent = styled.div`
  display: flex;
  justify-content: space-between;
  gap: var(--space-20);
  margin-left: var(--space-24);
  .loading-animation {
    overflow: hidden;
  }

  .loading-animation::before {
    content: '';
    display: block;
    height: 100%;
    width: 100%;
    animation: loading 1s infinite;
    background: linear-gradient(to right, transparent, var(--background-tertiary), transparent);
  }

  @keyframes loading {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
`;

const LeftContent = styled.div`
  display: flex;
  width: 100%;
  max-width: 678px;
`;

const RightContent = styled.div``;

const ActivityBox = styled.div`
  width: 274px;
`;

const Activity = styled.div`
  background: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-8);
  padding: var(--space-16);
  .last {
    margin-bottom: var(--space-0);
  }
`;
const TotalContent = styled.p`
  ${Typography.heading_md}
  align-items: center;
  margin: var(--space-0);
  color: var(--text-primary);
  padding-bottom: var(--space-6);
`;
const ActivityBottom = styled.div`
  margin-bottom: var(--space-16);
  border-top: 0.5px solid var(--border-primary);
  display: flex;
  gap: var(--space-12);
  flex-direction: column;
`;

const Title = styled.div`
  background: var(--background-muted);
  border-radius: var(--border-radius-6);
  width: 134px;
  height: 8px;
  margin-top: var(--space-16);
`;

const Desc = styled.div`
  background: var(--background-muted);
  border-radius: var(--border-radius-6);
  width: 74px;
  height: 6px;
`;
const MainDiv = styled.div<Props>`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
  max-width: 678px;
  .after {
    border: 0.5px solid var(--border-primary);
    width: 24px;
    height: 100%;
    border-radius: var(--border-radius-0) var(--border-radius-8) var(--border-radius-8) var(--border-radius-0);
    ${(props: Props) =>
      props.isDark === 'light'
        ? css`
            background-image: url("data:image/svg+xml,%3Csvg width='8' height='8' viewBox='0 0 16 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fillRule='evenodd' clipRule='evenodd' d='M7 12.3422C10.3137 12.3422 13 9.69115 13 6.42087C13 3.1506 10.3137 0.499512 7 0.499512C3.68629 0.499512 1 3.1506 1 6.42087C1 9.69115 3.68629 12.3422 7 12.3422Z' fill='%23F6F9FC' stroke='%23E3E8EA' strokeWidth='0.888889'/%3E%3C/svg%3E");
          `
        : css`
            background-image: url("data:image/svg+xml,%3Csvg width='8' height='8' viewBox='0 0 16 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fillRule='evenodd' clipRule='evenodd' d='M7 12.3422C10.3137 12.3422 13 9.69115 13 6.42087C13 3.1506 10.3137 0.499512 7 0.499512C3.68629 0.499512 1 3.1506 1 6.42087C1 9.69115 3.68629 12.3422 7 12.3422Z' fill='%232E2E30' stroke='%232E2E30' strokeWidth='0.888889'/%3E%3C/svg%3E");
          `}
    background-repeat: repeat-y;
    background-position: center;
    background-size: 18px;
    position: absolute;
    right: -25px;
  }
  .before {
    position: absolute;
    border: 0.5px solid var(--border-primary);
    width: 24px;
    height: 100%;
    ${(props: Props) =>
      props.isDark === 'light'
        ? css`
            background-image: url("data:image/svg+xml,%3Csvg width='8' height='8' viewBox='0 0 16 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fillRule='evenodd' clipRule='evenodd' d='M7 12.3422C10.3137 12.3422 13 9.69115 13 6.42087C13 3.1506 10.3137 0.499512 7 0.499512C3.68629 0.499512 1 3.1506 1 6.42087C1 9.69115 3.68629 12.3422 7 12.3422Z' fill='%23F6F9FC' stroke='%23E3E8EA' strokeWidth='0.888889'/%3E%3C/svg%3E");
          `
        : css`
            background-image: url("data:image/svg+xml,%3Csvg width='8' height='8' viewBox='0 0 16 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fillRule='evenodd' clipRule='evenodd' d='M7 12.3422C10.3137 12.3422 13 9.69115 13 6.42087C13 3.1506 10.3137 0.499512 7 0.499512C3.68629 0.499512 1 3.1506 1 6.42087C1 9.69115 3.68629 12.3422 7 12.3422Z' fill='%232E2E30' stroke='%232E2E30' strokeWidth='0.888889'/%3E%3C/svg%3E");
          `}
    border-radius: var(--border-radius-8) var(--border-radius-0) var(--border-radius-0) var(--border-radius-8);
    background-repeat: repeat-y;
    background-position: center;
    background-size: 18px;
    left: -25px;
  }
`;

const TopInvoice = styled.div`
  display: flex;
  justify-content: space-between;
  padding-inline: var(--space-20);
`;
const InvoiceLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-36);
  margin-top: var(--space-24);
`;
const Details = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-18);
`;

const InputId = styled.div`
  display: flex;
  gap: var(--space-14);
  .last {
    width: 119px;
  }
`;

const InputTitle = styled.div`
  background: var(--background-muted);
  border-radius: var(--border-radius-6);
  width: 65px;
  height: 8px;
`;

const InputDesc = styled.div`
  background: var(--background-muted);
  border-radius: var(--border-radius-6);
  width: 65px;
  height: 8px;
`;
const InvoiceRight = styled.div`
  margin-top: var(--space-24);
  display: flex;
  flex-direction: column;
  gap: var(--space-36);
  max-width: 238px;
  width: 100%;
`;

const Title2 = styled.div`
  text-align: center;
  ${Typography.heading_lg}
  color: var(--text-primary);
`;
const Box = styled.div`
  display: flex;
  gap: var(--space-20);
  .title {
    margin-top: var(--space-0);
  }
`;

const Address = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-24);
`;
const From = styled.div`
  background: var(--background-muted);
  border-radius: var(--border-radius-6);
  width: 40px;
  height: 8px;
`;

const Rightbox = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
`;

const RightBottom = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  .second {
    width: 118px;
  }
  .third {
    width: 64px;
  }
`;

const First = styled.div`
  background: var(--background-muted);
  border-radius: var(--border-radius-6);
  width: 178px;
  height: 6px;
`;
const InvoiceTable = styled.div``;
const GroupHeader = styled.div`
  padding: var(--space-12) var(--space-18);
  justify-content: space-between;
  display: flex;
  border-top: 0.5px solid var(--border-primary);
  background: var(--background-tertiary);
  margin-top: var(--space-36);
`;
const RightHeader = styled.div`
  ${AlignCenter}
`;
const Label = styled.p`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  margin: var(--space-0);
  text-transform: uppercase;
`;
const Quantity = styled.p`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  border-left: 0.5px solid var(--border-primary);
  border-right: 0.5px solid var(--border-primary);
  padding-inline: var(--space-12) var(--space-16);
  margin: var(--space-0);
  text-transform: uppercase;
`;
const Amount = styled.p`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  padding-left: var(--space-40);
  margin: var(--space-0);
  text-transform: uppercase;
`;
const Price = styled.p`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  border-right: 0.5px solid var(--border-primary);
  padding-inline: var(--space-12) var(--space-24);
  margin: var(--space-0);
  text-transform: uppercase;
`;

const Row = styled.div`
  padding: var(--space-14) var(--space-18);
  display: flex;
  justify-content: space-between;
  border-top: 0.5px solid var(--border-primary);
`;
const LeftRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-11);
`;

const RightRow = styled.div`
  display: flex;
  gap: var(--space-36);
`;
const QuantityRate = styled.div`
  background-color: var(--background-muted);
  width: 38px;
  height: 8px;
  border-radius: var(--border-radius-6);
  text-align: end;
`;

const AmountRate = styled.div`
  background-color: var(--background-muted);
  width: 69px;
  height: 8px;
  border-radius: var(--border-radius-6);
  text-align: end;
`;
const InfoRate = styled.div`
  background-color: var(--background-muted);
  width: 69px;
  height: 8px;
  border-radius: var(--border-radius-6);
  text-align: end;
`;

const Topleft = styled.div`
  width: 267px;
  height: 8px;
  border-radius: var(--border-radius-6);
  background: var(--background-muted);
`;

const TopBottom = styled.div`
  width: 169px;
  height: 8px;
  border-radius: var(--border-radius-6);
  background: var(--background-muted);
`;
const Total = styled.div`
  padding: var(--space-36) var(--space-20);
  border-top: 0.5px solid var(--border-primary);
  border-bottom: 0.5px solid var(--border-primary);
  gap: var(--space-24);
  display: flex;
  flex-direction: column;
`;
const Line = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: var(--space-40);
  .first {
    width: 61px;
  }
  .second {
    width: 109px;
  }
`;
const Heading = styled.div`
  background-color: var(--background-muted);
  width: 73px;
  height: 8px;
  border-radius: var(--border-radius-6);
`;

const Description = styled.div`
  background-color: var(--background-muted);
  width: 61px;
  height: 8px;
  border-radius: var(--border-radius-6);
`;
const Note = styled.div`
  padding: var(--space-24) var(--space-18);
  display: flex;
  flex-direction: column;
  gap: var(--space-16);
`;
const NoteTitle = styled.div`
  background-color: var(--background-muted);
  width: 60px;
  height: 8px;
  border-radius: var(--border-radius-6);
`;

const NoteDescription = styled.div`
  background-color: var(--background-muted);
  width: 367px;
  height: 8px;
  border-radius: var(--border-radius-6);
`;

export {
  MainContent,
  LeftContent,
  RightContent,
  ActivityBox,
  Activity,
  TotalContent,
  ActivityBottom,
  Title,
  Desc,
  MainDiv,
  TopInvoice,
  InvoiceLeft,
  Details,
  InputId,
  InputTitle,
  InputDesc,
  InvoiceRight,
  Title2,
  Box,
  Address,
  From,
  Rightbox,
  RightBottom,
  First,
  InvoiceTable,
  Label,
  RightHeader,
  GroupHeader,
  Price,
  Amount,
  Quantity,
  Row,
  LeftRow,
  RightRow,
  QuantityRate,
  AmountRate,
  InfoRate,
  Topleft,
  TopBottom,
  Total,
  Line,
  Heading,
  Description,
  Note,
  NoteTitle,
  NoteDescription
};
